import { useEffect, useRef, useState } from 'react';

import { Copy01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button } from 'components/FormComponents';

import { messagePopOut, selectApp } from 'api/app-slice';
import { selectAuthentication } from 'api/authentication-slice';

import { Loading } from '../../components/Loading/Loading';
import AppMessage from '../AppPage/AppMessage/AppMessage';
import { AdminNavbar } from './AdminNavbar/AdminNavbar';
import styles from './AdminPage.module.scss';

const AdminPage = ({
  title,
  subtitle,
  loading,
  button,
  buttonText = 'Save',
  children,
  copyToClipboard = false,
  onClick = () => {},
  allowedRole,
}) => {
  const dispatch = useDispatch();
  const titleRef = useRef();

  const authentication = useSelector(selectAuthentication);
  const app = useSelector(selectApp);

  const [authenticating, setAuthenticating] = useState(true);
  const [copied, setCopied] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(messagePopOut());
  }, []);

  useEffect(() => {
    if (!authentication?.checked) return;
    else if (!authentication?.logged) navigate(`/sign_in?redirect_uri=${window.location.pathname}`);
    else if (!authentication?.admin) navigate('/dashboard');
    else if (!authentication.admin_permissions.includes(allowedRole)) navigate('/admin/companies');

    setAuthenticating(false);
  }, [authentication.checked]);

  const handleCopyToClipboard = async () => {
    if (titleRef.current) {
      try {
        await navigator.clipboard.writeText(titleRef.current.textContent);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 5000);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    }
  };

  return (
    <div className={styles.root}>
      <Loading active={loading || authenticating}></Loading>
      <AdminNavbar />
      <AppMessage {...app.message} />
      <div>
        <div className={styles.header}>
          <div className="d-flex align-items-center u-gap">
            <div className="d-flex flex-column">
              <h1 ref={titleRef} className={styles.title}>
                {title}
              </h1>
              {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            </div>
            {copyToClipboard && (
              <OverlayTrigger
                key={title}
                overlay={<Tooltip>{copied ? 'Copied to clipboard' : 'Copy to clipboard'}</Tooltip>}>
                <HugeiconsIcon
                  size={24}
                  icon={Copy01Icon}
                  className="u-pointer tertiary-text"
                  strokeWidth={2}
                  onClick={handleCopyToClipboard}
                />
              </OverlayTrigger>
            )}
          </div>
          {button && <Button onClick={onClick}>{buttonText}</Button>}
        </div>
        {children}
      </div>
    </div>
  );
};

export default AdminPage;
